// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
})

export const FieldWrapper = styled('div', {
  flexGrow: 1,
  marginTop: '-13px',
  marginRight: '10px',
})

export const ButtonWrapper = styled('div', {
  marginTop: '10px',
})
